module.exports = __webpack_public_path__ + "img/per.ea95116f.svg";